import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QuillModule } from 'ngx-quill';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommunicationPreviewComponent } from './components/communication-preview/communication-preview.component';
import { ShareDocumentComponent } from './components/share-document/share-document.component';
import { ShareDocumentDialogComponent } from './components/share-document-dialog/share-document-dialog.component';
import { SharingEffects } from './store/sharing.effects';
import { SharingFeatureKey, reducer } from './store/sharing.reducer';
import { ShareDocumentEverbridgeDialogComponent } from './components/share-document-everbridge-dialog/share-document-everbridge-dialog.component';
import { SafeHtmlPipe } from '@app/shared/pipes/safe-html.pipe';

@NgModule({
  declarations: [
    CommunicationPreviewComponent,
    ShareDocumentComponent,
    ShareDocumentDialogComponent,
    ShareDocumentEverbridgeDialogComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    TranslateModule,
    FlexLayoutModule,
    QuillModule,
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    StoreModule.forFeature(SharingFeatureKey, reducer),
    EffectsModule.forFeature([SharingEffects]),
    SafeHtmlPipe
  ],
  exports: [CommunicationPreviewComponent, ShareDocumentComponent, ShareDocumentDialogComponent, ShareDocumentEverbridgeDialogComponent]
})
export class ShareCommunicationModule {}
